import clsx from 'clsx';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import styles from './inlineAlert.module.scss';

type InlineAlertProps = {
  children: string | React.ReactNode;
  className?: string;
  /** When false, the error icon is omitted (e.g. purely informational messages). */
  showIcon?: boolean;
};

export function InlineAlert({
  children,
  className,
  showIcon = true,
}: InlineAlertProps) {
  return (
    <div className={clsx(styles['alert'], className)}>
      {showIcon ? (
        <GoogleFontIcon className={styles['alert__icon']} name="report" solid />
      ) : null}
      {children}
    </div>
  );
}
